<template>
  <div
    class="
      cbg-white-container
      input-container
      theme--light
      v-card
      p-16
      border-card
    "
  >
    <v-row>
      <v-col cols="12" md="3" class="calendar-point position-relative">
        <label for>Date</label>
        <datepicker
          v-model="date"
          @input="filterDate()"
          ref="datepicker"
          :max-date="new Date()"
          :masks="{ input: 'DD/MM/YYYY' }"
        >
          <template v-slot="{ inputValue, inputEvents }">
            <input
              class="form-control pos-r"
              placeholder="DD/MM/YYYY"
              :value="inputValue"
              v-on="inputEvents"
            />
          </template>
        </datepicker>
        <div class="calendarsvg userinputcalendar pos-a">
          <calendarSVG />
        </div>
      </v-col>
      <v-col sm="12" md="3">
        <div class="position-relative">
          <label for>Role</label>
          <select
            v-model="role"
            @change="onRoleChange()"
            name
            id
            class="form-control"
          >
            <option value="all">All</option>
            <option value="pharmacy">Pharmacy</option>
            <option value="diagnostics-lab">Diagnostics</option>
            <option value="bloodbank">Bloodbank</option>
            <option value="ambulance">Ambulance</option>
          </select>
          <span class="drop-icon">
            <i
              aria-hidden="true"
              class="v-icon mdi mdi-menu-down theme--light position-absolute"
            ></i>
          </span>
        </div>
      </v-col>
      <v-col cols="12" md="3">
        <label for>Search by Saathi code</label>
        <input
          class="form-control"
          placeholder="code"
          v-model="search"
          @input="debounceSearch()"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="table-div overflow-auto">
          <table class="table">
            <thead>
              <tr class="table-success">
                <th>DocSmart user name</th>
                <th>DocSmart user number</th>
                <th>Role</th>
                <th>Centre name</th>
                <th>Saathi Code</th>
                <th>Is onboarded</th>
                <th>Is Subscribed</th>
                <th>Subscribed via</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(user, index) in users" :key="index">
                <td>{{ user.name }}</td>
                <td>{{ user.mobile }}</td>
                <td>{{ user.center.role }}</td>
                <td>{{ user.center.name }}</td>
                <td>{{ user.saathi_code }}</td>
                <td>Yes</td>
                <td>{{ user.is_subscribed ? "Yes" : "No" }}</td>
                <td>{{ subscribedVia(user) }}</td>
                <td>
                  <span v-if="user.user_subscriptions">{{
                    getDate(user.user_subscriptions.created_at)
                  }}</span>
                  <span v-else>{{ getDate(user.date_of_onboarding) }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <pagination
          v-if="!isEmpty"
          class="mx-6"
          :currentPage="page"
          :recordPerPage="recordsPerPage"
          :total="total"
          @changePage="changePage"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { pickSvg } from "@/views/SVG";
import config from "@/config.js";
import debounce from "lodash/debounce";
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
const dayJS = require("@/methods/dayjs")
  .advancedFormat()
  .customParseFormat()
  .isBetween()
  .build();
export default {
  data() {
    return {
      dayJS,
      status: "onboarded",
      role: "all",
      users: [],
      saathiCode: null,
      page: 1,
      recordsPerPage: 10,
      total: 0,
      isEmpty: true,
      showSubscriptionDetailsModal: false,
      subscriptionDetail: null,
      date: "",
      search: "",
    };
  },
  components: {
    pagination: () => import("@/views/common/Pagination"),
    Datepicker,
    ...pickSvg("crossSVG"),
  },
  methods: {
    filterDate() {
      this.getUsers();
    },
    clearDateFilter() {
      this.date = "";
      this.getUsers();
    },
    getDate(date) {
      return dayJS(date).format("DD/MM/YYYY");
    },
    onRoleChange() {
      this.page = 1;
      this.getUsers();
    },
    onStatusChange() {
      this.page = 1;
      this.getUsers();
    },
    subscribedVia(user) {
      if (!user.user_subscriptions) return "-";
      if (user.user_subscriptions.source_from === "VIA_DOCSMART")
        return "Docsmart";
      else if (
        ["VIA_SEVA_USER", "VIA_DOCSMART_BY_SEVA_USER"].includes(
          user.user_subscriptions.source_from
        )
      )
        return "SEVA";
    },
    debounceSearch: debounce(function () {
      this.isEmpty = true;
      this.page = 1;
      this.getUsers();
    }, 500),
    changePage(page) {
      this.page = page.currentPage;
      this.getUsers();
    },
    getUsers() {
      let params = {
        search: this.search,
        records_per_page: this.recordsPerPage,
        page: this.page,
      };
      if (this.date) {
        params.date = new Date(this.date).toISOString();
      }
      let url = `${config.BASE_URL}api/v2/admin/seva/${this.role}/user-by-seva`;
      this.$http.get(url, { params }).then((response) => {
        if (response.body.status) {
          if (response.body.data.total > 0) this.isEmpty = false;
          else this.isEmpty = true;
          this.page = response.body.data.page;
          this.recordsPerPage = response.body.data.limit;
          this.total = response.body.data.count;
          this.users = response.body.data.list;
        }
      });
    },
    showSubscriptionDetails(subscription) {
      this.subscriptionDetail = subscription;
      this.showSubscriptionDetailsModal = true;
    },
  },
  mounted() {
    this.date = new Date(
      this.dayJS(new Date()).subtract(1, "day").startOf("day")
    );
    this.getUsers();
  },
};
</script>
<style lang="scss" scoped>
.cross-svg {
  position: absolute;
  top: 3.2rem;
  right: 1.4rem;
  svg {
    width: 1.3rem;
  }
}
</style>
